import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getCompanies } from '../api';

const API_URL = process.env.REACT_APP_API_URL || 'https://stock-api-production-913a.up.railway.app';

import { InlineTimer } from '../components/AILoadingIndicator';
const I_TRIGRAMS = {
  7:{name:'乾',symbol:'☰',element:'天'}, 3:{name:'兌',symbol:'☱',element:'澤'},
  5:{name:'離',symbol:'☲',element:'火'}, 1:{name:'震',symbol:'☳',element:'雷'},
  6:{name:'巽',symbol:'☴',element:'風'}, 2:{name:'坎',symbol:'☵',element:'水'},
  4:{name:'艮',symbol:'☶',element:'山'}, 0:{name:'坤',symbol:'☷',element:'地'},
};
const I_HEX_TABLE = {
  7:{7:1,3:43,5:14,1:34,6:9,2:5,4:26,0:11}, 3:{7:10,3:58,5:38,1:54,6:61,2:60,4:41,0:19},
  5:{7:13,3:49,5:30,1:55,6:37,2:63,4:22,0:36}, 1:{7:25,3:17,5:21,1:51,6:42,2:3,4:27,0:24},
  6:{7:44,3:28,5:50,1:32,6:57,2:48,4:18,0:46}, 2:{7:6,3:47,5:64,1:40,6:59,2:29,4:4,0:7},
  4:{7:33,3:31,5:56,1:62,6:53,2:39,4:52,0:15}, 0:{7:12,3:45,5:35,1:16,6:20,2:8,4:23,0:2},
};
const I_HEXAGRAMS = {
  1:{name:'乾',full:'乾為天',theme:'剛健進取',desc:'天道不息，生生不滅。此卦大吉，宜積極行動，把握良機，凡事自強不息，必能成就大業。'},
  2:{name:'坤',full:'坤為地',theme:'柔順厚德',desc:'大地廣博，萬物載育。宜低調謙遜、腳踏實地，靜待時機，以柔克剛，終能成事。'},
  3:{name:'屯',full:'水雷屯',theme:'初生艱難',desc:'萬物初生，草木破土。當前剛起步，阻礙重重，只要堅持終有突破，宜尋求貴人相助。'},
  4:{name:'蒙',full:'山水蒙',theme:'啟蒙學習',desc:'童蒙求學，初識世界。宜虛心學習，向有經驗的人請教，循序漸進，必有所得。'},
  5:{name:'需',full:'水天需',theme:'等待時機',desc:'雲雨聚積，等待降臨。時機未到，宜耐心等待，養精蓄銳，時機成熟水到渠成。'},
  6:{name:'訟',full:'天水訟',theme:'慎防爭端',desc:'易生爭端，遇事宜退讓和解，不可意氣用事，若已涉訟，宜早日和解為上。'},
  7:{name:'師',full:'地水師',theme:'統帥謀略',desc:'宜謀定而後動，集合眾力，統一方向，切忌各行其是，以正道行事定能克敵制勝。'},
  8:{name:'比',full:'水地比',theme:'親密合作',desc:'宜廣結善緣，與志同道合者合作，互助互信，事業與人際都將大有斬獲。'},
  9:{name:'小畜',full:'風天小畜',theme:'小有積蓄',desc:'目前條件尚不充分，宜做好準備，積累資源，暫時等待是為了更大的成功。'},
  10:{name:'履',full:'天澤履',theme:'謹慎行事',desc:'如同踩在老虎尾巴上。凡事謹慎，遵守規範，不可輕率妄為，以正直之心行事，化險為夷。'},
  11:{name:'泰',full:'地天泰',theme:'通泰順遂',desc:'此卦大吉，諸事順利，上下和諧，是進取的好時機，把握良機積極行動，福祉自來。'},
  12:{name:'否',full:'天地否',theme:'閉塞不通',desc:'此時諸事不順，宜守住自身，靜待否極泰來，不可強行突破，韜光養晦等待轉機。'},
  13:{name:'同人',full:'天火同人',theme:'同心協力',desc:'宜與他人合作，開誠布公，凝聚共識，以大局為重，同心協力必克萬難。'},
  14:{name:'大有',full:'火天大有',theme:'豐盛富足',desc:'此卦大吉，事業豐收，財運旺盛，宜廣施恩惠，分享成果，懷謙遜之心方可長久。'},
  15:{name:'謙',full:'地山謙',theme:'謙遜自牧',desc:'謙虛是最高美德，不可驕傲自大，謙者受益，終將得到眾人的尊重。'},
  16:{name:'豫',full:'雷地豫',theme:'歡悅樂觀',desc:'宜展現熱忱，鼓舞眾人，樂觀的態度能帶來好運，凡事往好處想。'},
  17:{name:'隨',full:'澤雷隨',theme:'順勢而為',desc:'宜順應時勢，靈活應對，跟隨正確的方向與有能力的人，定能獲益。'},
  18:{name:'蠱',full:'山風蠱',theme:'撥亂反正',desc:'宜勇於革新，整頓積弊，不可因循苟且，改革雖難，但長遠有益。'},
  19:{name:'臨',full:'地澤臨',theme:'親臨視察',desc:'宜主動積極，親力親為，善用影響力，凡事將大有進展。'},
  20:{name:'觀',full:'風地觀',theme:'靜觀其變',desc:'宜退一步冷靜觀察，思考全局，了解形勢後再做決定，洞察入微方能制勝。'},
  21:{name:'噬嗑',full:'火雷噬嗑',theme:'克服障礙',desc:'面對障礙要果斷處理，不可拖延，以強硬手段突破阻礙，事情可以解決。'},
  22:{name:'賁',full:'山火賁',theme:'文飾修美',desc:'宜提升品味，美化環境，但不可只重外表忽視實質，內外兼修方好。'},
  23:{name:'剝',full:'山地剝',theme:'損剝不利',desc:'此卦不利行動，宜忍耐守靜，等待危機自然消退，保存實力才是上策。'},
  24:{name:'復',full:'地雷復',theme:'重新出發',desc:'否極泰來，困境即將過去，新的機會正在到來，宜重整旗鼓重新出發，一切都會好轉。'},
  25:{name:'無妄',full:'天雷無妄',theme:'純正無私',desc:'凡事依照正道行事，不可妄想僥倖，坦誠正直，自然天道酬勤。'},
  26:{name:'大畜',full:'山天大畜',theme:'厚積薄發',desc:'宜努力積累知識與資源，適時推出必將一鳴驚人，大有所成。'},
  27:{name:'頤',full:'山雷頤',theme:'養正自持',desc:'注意飲食起居與身心調養，謹言慎行，養成良好習慣，萬事順遂。'},
  28:{name:'大過',full:'澤風大過',theme:'力排眾難',desc:'需要非常的勇氣與行動力，宜當機立斷，力挽狂瀾，事可轉危為安。'},
  29:{name:'坎',full:'坎為水',theme:'重重險阻',desc:'前路多有艱難，宜保持信念不動搖，以誠信之心度過險境，熬過去就是晴天。'},
  30:{name:'離',full:'離為火',theme:'光明附麗',desc:'宜發揮才華，展現光芒，以正直之心依附正確方向，事業將光明燦爛。'},
  31:{name:'咸',full:'澤山咸',theme:'感應交流',desc:'宜以真誠感動他人，虛心感受對方，雙向交流，感情與合作都將有所收穫。'},
  32:{name:'恆',full:'雷風恆',theme:'持之以恆',desc:'凡事貴在堅持，三分鐘熱度成不了大事，持之以恆終將水滴石穿，達成目標。'},
  33:{name:'遯',full:'天山遯',theme:'適時退隱',desc:'在不利環境下退隱是智慧，保存實力等待時機，不可硬碰硬，退一步海闊天空。'},
  34:{name:'大壯',full:'雷天大壯',theme:'剛壯有力',desc:'力量充沛，宜以正道行事，勿仗勢欺人，正確運用能量，將帶來顯著成就。'},
  35:{name:'晉',full:'火地晉',theme:'晉升前進',desc:'此卦大吉，宜積極進取，展現才能，機會就在眼前，勇於表現，晉升與成功唾手可得。'},
  36:{name:'明夷',full:'地火明夷',theme:'韜光養晦',desc:'環境艱難，宜隱藏鋒芒，默默積累力量，等待黎明到來。'},
  37:{name:'家人',full:'風火家人',theme:'齊家守正',desc:'宜注重家庭關係，各守其位，以正道齊家，家和萬事興。'},
  38:{name:'睽',full:'火澤睽',theme:'對立分歧',desc:'宜尋求共識，以大局為重，求同存異，化解對立，才能共創局面。'},
  39:{name:'蹇',full:'水山蹇',theme:'步履維艱',desc:'宜暫停反思，尋求幫助，不可一意孤行，適時回頭重整，再求前進。'},
  40:{name:'解',full:'雷水解',theme:'解除困難',desc:'困境正在解除，宜把握時機果斷行動，趁機清除障礙，輕裝上陣前行。'},
  41:{name:'損',full:'山澤損',theme:'損下益上',desc:'宜節制欲望，有所犧牲，以誠心奉獻，看似虧損實則積德，長遠必有回報。'},
  42:{name:'益',full:'風雷益',theme:'增益獲利',desc:'此卦大吉，宜積極行動，抓住機遇，此時行善或投資將有豐厚回報。'},
  43:{name:'夬',full:'澤天夬',theme:'決斷果行',desc:'面對問題要果斷決策，不可猶豫，以正直之心揭露問題，清除障礙。'},
  44:{name:'姤',full:'天風姤',theme:'不期而遇',desc:'可能遇到意外的相遇或機會，但也要小心不速之客，審慎辨別，不可輕易接受誘惑。'},
  45:{name:'萃',full:'澤地萃',theme:'聚集凝聚',desc:'宜廣聚資源與人才，凝聚力量，團結眾人，眾人拾柴火焰高，必能成大事。'},
  46:{name:'升',full:'地風升',theme:'漸進上升',desc:'宜腳踏實地，一步一腳印，不求速成，穩健前進必能達到目標。'},
  47:{name:'困',full:'澤水困',theme:'陷於困境',desc:'當前處於困境，但君子處困仍不失節操，忍耐當下，保持信念，困境終將過去。'},
  48:{name:'井',full:'水風井',theme:'取之不盡',desc:'宜深耕自身才能，提升自我，廣施恩惠，福澤眾人，智慧與資源取之不盡。'},
  49:{name:'革',full:'澤火革',theme:'改革創新',desc:'改革的時機已到，宜果斷進行變革，告別舊有模式，迎接新的開始。'},
  50:{name:'鼎',full:'火風鼎',theme:'鼎革新成',desc:'宜整合資源，以全新的方式重新出發，創立新局，功成名就。'},
  51:{name:'震',full:'震為雷',theme:'震動警醒',desc:'宜提高警覺，以謹慎的態度應對突如其來的衝擊，化震驚為行動力。'},
  52:{name:'艮',full:'艮為山',theme:'靜止沉潛',desc:'停下腳步，靜心思考，不被外界干擾，充實內在，找到心靈的安定。'},
  53:{name:'漸',full:'風山漸',theme:'漸進有序',desc:'凡事循序漸進，欲速則不達，穩健發展，不可躁進。'},
  54:{name:'歸妹',full:'雷澤歸妹',theme:'委曲求全',desc:'需了解自己的位置，不可強求，委曲求全有時是智慧，但也要守護自身的底線。'},
  55:{name:'豐',full:'雷火豐',theme:'豐盛昌隆',desc:'此卦大吉，事業財運正處高峰，宜積極行動，廣結善緣，把握豐盛時機。'},
  56:{name:'旅',full:'火山旅',theme:'旅途奔波',desc:'宜謹慎行事，保持靈活應變，廣結善緣尋覓貴人助力。'},
  57:{name:'巽',full:'巽為風',theme:'柔順謙遜',desc:'宜以柔和方式溝通，循序漸進達成目標，切忌強硬，謙遜入手事半功倍。'},
  58:{name:'兌',full:'兌為澤',theme:'喜悅和樂',desc:'宜廣結善緣，言語和氣，以真誠的喜悅感染他人，人際關係十分順利。'},
  59:{name:'渙',full:'風水渙',theme:'渙散分離',desc:'宜加強溝通，整合資源，化渙為聚，重建秩序，防止人心渙散。'},
  60:{name:'節',full:'水澤節',theme:'節制有度',desc:'凡事適可而止，訂立合理規範並遵守，節制是通往成功的關鍵。'},
  61:{name:'中孚',full:'風澤中孚',theme:'誠信感人',desc:'以誠信待人，真心誠意最能感動他人，信譽是最寶貴的資產。'},
  62:{name:'小過',full:'雷山小過',theme:'謹小慎微',desc:'宜處理小事，不宜大動作，凡事謹慎小心，保守穩健為上。'},
  63:{name:'既濟',full:'水火既濟',theme:'功成圓滿',desc:'事情已達圓滿，宜居安思危，鞏固成果，未雨綢繆以防物極必反。'},
  64:{name:'未濟',full:'火水未濟',theme:'尚未完成',desc:'事情尚未到達終點，還有一段路要走，宜繼續努力，成功就在不遠前方。'},
};
function iCastLines() { return Array.from({length:6}, () => Math.floor(Math.random()*2)); }
function iLinesToTrigram(lines) { return lines[2]*4 + lines[1]*2 + lines[0]; }
function iGetHexNum(lines) {
  const lower = iLinesToTrigram(lines.slice(0,3));
  const upper = iLinesToTrigram(lines.slice(3,6));
  return I_HEX_TABLE[upper]?.[lower] ?? 1;
}
function ILine({ isYang, visible }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:6, height:12, opacity:visible?1:0, transition:'opacity 0.4s' }}>
      {isYang ? (
        <div style={{ width:72, height:7, background:'linear-gradient(90deg,#f5c518,#ffaa00)', borderRadius:3 }} />
      ) : (
        <>
          <div style={{ width:30, height:7, background:'linear-gradient(90deg,#4a6878,#7ab0cc)', borderRadius:3 }} />
          <div style={{ width:8 }} />
          <div style={{ width:30, height:7, background:'linear-gradient(90deg,#7ab0cc,#4a6878)', borderRadius:3 }} />
        </>
      )}
    </div>
  );
}

const PASSWORD = 'sss901114';

const S = {
  sec: { background: '#080b10', border: '1px solid #1a2a3c', marginBottom: 1, padding: '16px 20px' },
  label: { color: '#90c0dc', fontSize: 10, letterSpacing: 3, fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, marginBottom: 8, display: 'block' },
  input: { width: '100%', background: '#060910', border: '1px solid #2a5070', padding: '8px 12px', color: '#c0d8ea', fontSize: 13, outline: 'none', fontFamily: "'Barlow',sans-serif", marginBottom: 8 },
  btn: (bg='#2e5872') => ({ padding: '7px 18px', background: `linear-gradient(135deg,${bg},${bg}bb)`, color: '#eef8ff', border: 'none', cursor: 'pointer', fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, fontSize: 12, letterSpacing: 2, marginRight: 8 }),
  title: { fontFamily: "'Rajdhani',sans-serif", fontSize: 13, fontWeight: 700, letterSpacing: 2, color: '#90c0dc', marginBottom: 10 },
};

export default function PrivateAnalysis({ ticker: globalTicker = '2330' }) {
  // 易經人生
  const [iLines, setILines] = useState(null);
  const [iHexNum, setIHexNum] = useState(null);
  const [iVisible, setIVisible] = useState(0);
  const [iCasting, setICasting] = useState(false);
  const [iInterp, setIInterp] = useState('');
  const [iLoading, setILoading] = useState(false);
  const [iQuestion, setIQuestion] = useState('');
  const [iCategory, setICategory] = useState('invest');

  const iCast = useCallback(async () => {
    if (iCasting || iLoading) return;
    setICasting(true); setILines(null); setIHexNum(null); setIVisible(0); setIInterp('');
    await new Promise(r => setTimeout(r, 500));
    const newLines = iCastLines();
    const num = iGetHexNum(newLines);
    setILines(newLines); setIHexNum(num); setICasting(false);
    for (let i = 1; i <= 6; i++) { await new Promise(r => setTimeout(r, 280)); setIVisible(i); }
    setILoading(true);
    const hex = I_HEXAGRAMS[num];
    const lower = I_TRIGRAMS[iLinesToTrigram(newLines.slice(0,3))];
    const upper = I_TRIGRAMS[iLinesToTrigram(newLines.slice(3,6))];
    const isInvest = iCategory === 'invest';
    const invest_hint = isInvest ? '包含對市場時機、風險與操作策略的看法' : '包含對情況的深入洞察與應對之道';
    const category_hint = isInvest
      ? '問卦者詢問的是【投資理財相關問題】，請從投資角度出發，結合卦象給出具體的市場觀點與操作建議。'
      : '問卦者詢問的是【人生、感情、工作、健康等生活事項】，請從人生哲理角度出發，給予溫暖而深刻的指引。';
    const question_hint = iQuestion
      ? `問卦者的具體問題是：「${iQuestion}」請讓解卦內容緊扣這個問題，給出與問題高度相關的分析。`
      : '問卦者未填具體問題，請給予通用而有深度的指引。';
    try {
      const res = await fetch(`${API_URL}/api/iching/interpret`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          hex_num: num, hex_name: hex.name, hex_full: hex.full,
          hex_theme: hex.theme, hex_desc: hex.desc,
          upper_name: upper.name, upper_elem: upper.element,
          lower_name: lower.name, lower_elem: lower.element,
          question: iQuestion, category: iCategory,
        })
      });
      const data = await res.json();
      setIInterp(data.interpretation || hex.desc);
    } catch { setIInterp(hex.desc); }
    setILoading(false);
  }, [iCasting, iLoading, iQuestion, iCategory]);
  // 當前分析個股
  const [analysisTicker, setAnalysisTicker] = useState(globalTicker);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [companies, setCompanies] = useState([]);

  // 營收分析
  const [revAnalysis, setRevAnalysis] = useState('');
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [aiInterpret, setAiInterpret] = useState('');
  const [aiInterpretLoading, setAiInterpretLoading] = useState(false);
  const [revLoading, setRevLoading] = useState(false);
  const [revData, setRevData] = useState(null);

  // ── 型態選股相關 state ──
  const [openSec, setOpenSec] = useState({});
  const [cupHandle, setCupHandle] = useState(null);
  const [cupLoading, setCupLoading] = useState(false);
  const [drought, setDrought] = useState(null);
  const [droughtLoading, setDroughtLoading] = useState(false);
  const [bigHolders, setBigHolders] = useState(null);
  const [bigHoldersLoading, setBigHoldersLoading] = useState(false);
  const [bigHoldersDecr, setBigHoldersDecr] = useState(null);
  const [bigHoldersTab, setBigHoldersTab] = useState('increase');
  const [epsAccel, setEpsAccel] = useState(null);
  const [epsAccelLoading, setEpsAccelLoading] = useState(false);
  const [marginRising, setMarginRising] = useState(null);
  const [marginRisingLoading, setMarginRisingLoading] = useState(false);
  const [masterScreen, setMasterScreen] = useState(null);
  const [masterLoading, setMasterLoading] = useState(false);
  const [roicMomentum, setRoicMomentum] = useState(null);
  const [roicMomentumLoading, setRoicMomentumLoading] = useState(false);

  // ── 私房股 set (從 localStorage / 後端 同步) ──
  const [watchlistSet, setWatchlistSet] = useState(new Set());
  const watchlistRef = useRef(new Set());
  useEffect(() => { watchlistRef.current = watchlistSet; }, [watchlistSet]);

  const toggleWatchlist = useCallback((ticker, name) => {
    const isAdmin = sessionStorage.getItem('wintime_admin') === '1';
    const inList = watchlistRef.current.has(ticker);
    setWatchlistSet(prev => {
      const next = new Set(prev);
      inList ? next.delete(ticker) : next.add(ticker);
      return next;
    });
    window.dispatchEvent(new CustomEvent('watchlistChanged', {
      detail: { action: inList ? 'remove' : 'add', ticker, name }
    }));
    if (isAdmin) {
      const url = inList
        ? `${API_URL}/api/watchlist/${ticker}`
        : `${API_URL}/api/watchlist/${ticker}?name=${encodeURIComponent(name || '')}`;
      fetch(url, { method: inList ? 'DELETE' : 'POST' }).catch(() => {});
    } else {
      try {
        const saved = JSON.parse(localStorage.getItem('wt_watchlist') || '[]');
        const updated = inList
          ? saved.filter(t => t !== ticker)
          : [...saved, ticker];
        localStorage.setItem('wt_watchlist', JSON.stringify(updated));
      } catch {}
    }
  }, []);

  useEffect(() => { getCompanies().then(setCompanies); }, []);

  // ── 杯柄 / 旱地拔蔥 / 大戶籌碼 / 私房股 同步 ──
  useEffect(() => {
    setCupLoading(true);
    fetch(`${API_URL}/api/pattern/cup-handle`)
      .then(r => r.json())
      .then(d => { if (d.ok) setCupHandle(d); })
      .catch(() => {})
      .finally(() => setCupLoading(false));
  }, []);

  useEffect(() => {
    setDroughtLoading(true);
    fetch(`${API_URL}/api/pattern/drought-breakout`)
      .then(r => r.json())
      .then(d => { if (d.ok) setDrought(d); })
      .catch(() => {})
      .finally(() => setDroughtLoading(false));
  }, []);

  useEffect(() => {
    setEpsAccelLoading(true);
    fetch(`${API_URL}/api/screen/eps-accel?limit=100`)
      .then(r => r.json())
      .then(d => { if (d.ok) setEpsAccel(d); })
      .catch(() => {})
      .finally(() => setEpsAccelLoading(false));
  }, []);

  useEffect(() => {
    setMarginRisingLoading(true);
    fetch(`${API_URL}/api/screen/margin-rising?limit=100`)
      .then(r => r.json())
      .then(d => { if (d.ok) setMarginRising(d); })
      .catch(() => {})
      .finally(() => setMarginRisingLoading(false));
  }, []);

  useEffect(() => {
    setMasterLoading(true);
    fetch(`${API_URL}/api/screen/master?limit=100`)
      .then(r => r.json())
      .then(d => { if (d.ok) setMasterScreen(d); })
      .catch(() => {})
      .finally(() => setMasterLoading(false));
  }, []);

  useEffect(() => {
    setRoicMomentumLoading(true);
    fetch(`${API_URL}/api/screen/roic-momentum?limit=100`)
      .then(r => r.json())
      .then(d => { if (d.ok) setRoicMomentum(d); })
      .catch(() => {})
      .finally(() => setRoicMomentumLoading(false));
  }, []);

  useEffect(() => {
    setBigHoldersLoading(true);
    Promise.all([
      fetch(`${API_URL}/api/big-holders-increase?direction=increase`).then(r => r.json()),
      fetch(`${API_URL}/api/big-holders-increase?direction=decrease`).then(r => r.json()),
    ]).then(([incr, decr]) => {
      if (incr.ok) setBigHolders(incr);
      if (decr.ok) setBigHoldersDecr(decr);
    }).catch(() => {}).finally(() => setBigHoldersLoading(false));
  }, []);

  useEffect(() => {
    const isAdmin = sessionStorage.getItem('wintime_admin') === '1';
    if (isAdmin) {
      fetch(`${API_URL}/api/watchlist`)
        .then(r => r.json())
        .then(d => { if (Array.isArray(d)) setWatchlistSet(new Set(d.map(s => s.ticker))); })
        .catch(() => {});
    } else {
      try {
        const saved = JSON.parse(localStorage.getItem('wt_watchlist') || '[]');
        setWatchlistSet(new Set(saved));
      } catch {}
    }
  }, []);

  // 搜尋（同sidebar風格：搜尋框只用來搜尋，選後清空，另外顯示選定的股票）
  // 加 200ms debounce 讓打字流暢
  const searchTimerRef = useRef(null);
  const handleSearch = (val) => {
    setSearchQuery(val);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    if (!val.trim()) { setSearchResults([]); return; }
    searchTimerRef.current = setTimeout(() => {
      const q = val.toLowerCase();
      setSearchResults(companies.filter(c =>
        c.ticker.toLowerCase().includes(q) || c.name.toLowerCase().includes(q)
      ).slice(0, 6));
    }, 200);
  };

  const selectStock = (ticker, name) => {
    setAnalysisTicker(ticker);
    setCompanyName(name || '');
    setSearchQuery('');
    setSearchResults([]);
  };

  useEffect(() => {
    setAnalysisTicker(globalTicker);
  }, [globalTicker]);

  useEffect(() => {
    if (analysisTicker) fetchRevData(analysisTicker);
  }, [analysisTicker]);

  const fetchRevData = async (t) => {
    try {
      const [qRes, mRes, infoRes] = await Promise.all([
        fetch(`${API_URL}/api/company/${t}/quarterly?limit=9999`),
        fetch(`${API_URL}/api/company/${t}/monthly?limit=9999`),
        fetch(`${API_URL}/api/company/${t}`),
      ]);
      const qData = await qRes.json();
      const mData = await mRes.json();
      const info = await infoRes.json();
      setCompanyName(info.name || t);
      setRevData({ qData, mData });
    } catch(e) { setRevData(null); }
  };

  const fetchStats = async (t) => {
    setStatsLoading(true); setStats(null); setAiInterpret('');
    try {
      const r = await fetch(`${API_URL}/api/company/${t}/radar-stats`);
      const d = await r.json();
      setStats(d);
    } catch(e) { setStats({error: '載入失敗'}); }
    setStatsLoading(false);
  };

  const interpretStats = async (statsData = null) => {
    const s = statsData || stats;
    if (!s) return;
    setAiInterpretLoading(true); setAiInterpret('');

    // 24小時快取
    const dd = new Date();
    const ck = `wintime_stats_${analysisTicker}_v4_${dd.getFullYear()}${dd.getMonth()}${dd.getDate()}`;
    try {
      const cached = localStorage.getItem(ck);
      if (cached) {
        const { data: cv, ts } = JSON.parse(cached);
        if (Date.now() - ts < 86400000) {
          setAiInterpret(cv); setAiInterpretLoading(false); return;
        }
      }
    } catch {}

    const prompt = `【公司鎖定 - 絕對不可違反】
本次分析的公司為：${companyName}（股票代號 ${analysisTicker}）
你必須只分析這家公司。報告中所有提及的公司名稱、股票代號都必須使用上述資訊。
禁止在報告中出現任何其他公司名稱（例如鴻海、台積電、聯發科等）或其他股票代號，即使統計數據看起來與其他公司相似也不行。
報告開頭請寫：「# ${analysisTicker}（${companyName}）財務統計分析解讀」

請解讀以下${companyName}（${analysisTicker}）的財務統計分析，用繁體中文，具體說明投資意義。

【因果方向 — 絕對不可違反，違反必須整篇重寫】
本分析的核心目的是「用領先指標預估未來營收」。除了第 1 項毛利率之外，第 2~8 項每個科目都是「因」、營收是「果」：科目先變動，隔幾季後營收才跟著變動。你必須一律以「這個科目現在變動，預告未來第幾季的營收會如何走」的方向解讀。
嚴禁反向（不可寫成「營收變動後，這些科目才跟著反應」「營收成長帶動存貨增加」之類）。

【統計數據】
1. 毛利率 vs 營收 連動性：r=${s.rev_gp_corr?.r}
   （此項判斷營收成長的「質」：r 為正 → 營收成長時毛利率同步提升＝量質齊揚；r 為負 → 營收成長但毛利率下滑＝衝量殺價、質沒跟上；r 近 0 → 量與質無連動）
2. 原料 領先營收：原料變動後第 ${s.rev_raw_lag?.best_lag} 季營收反映最強，r=${s.rev_raw_lag?.lags?.[s.rev_raw_lag?.best_lag]?.r}
3. 在製品 領先營收：第 ${s.rev_wip_lag?.best_lag} 季，r=${s.rev_wip_lag?.lags?.[s.rev_wip_lag?.best_lag]?.r}
4. 製成品 領先營收：第 ${s.rev_fg_lag?.best_lag} 季，r=${s.rev_fg_lag?.lags?.[s.rev_fg_lag?.best_lag]?.r}
5. 存貨（合計）領先營收：第 ${s.rev_inv_lag?.best_lag} 季，r=${s.rev_inv_lag?.lags?.[s.rev_inv_lag?.best_lag]?.r}
6. 不動產廠房設備 領先營收：第 ${s.rev_capex_lag?.best_lag} 季，r=${s.rev_capex_lag?.lags?.[s.rev_capex_lag?.best_lag]?.r}
7. 無形資產 領先營收：第 ${s.rev_intg_lag?.best_lag} 季，r=${s.rev_intg_lag?.lags?.[s.rev_intg_lag?.best_lag]?.r}
8. 合約負債 領先營收：第 ${s.rev_cl_lag?.best_lag} 季，r=${s.rev_cl_lag?.lags?.[s.rev_cl_lag?.best_lag]?.r}
9. 信號（存貨增加＋存貨週轉天數下降 → 下季營收增）命中率：${s.inv_ar_signal?.hit_rate}%（${s.inv_ar_signal?.signals}次信號中${s.inv_ar_signal?.correct}次正確）

資料期間：${s.start}～${s.end}，共${s.periods}季

請針對第 2~8 項，逐一說明「該科目現在的變化，預告未來第幾季營收會如何變動」，重點放在「如何用這些領先科目來預估未來營收」。第 1 項毛利率則專門說明「這家公司營收成長到底是量的成長，還是質（毛利率）也同步提升」。

【絕對禁止】禁止捏造或推估資料中沒有的數字，資料不足時直接說明。
【語言要求】全文使用繁體中文，採台灣慣用語，所有財務名詞一律用中文（例如：毛利率、資本支出、應收帳款、存貨、合約負債），不得出現英文縮寫或英文術語。
【嚴禁中國用語 - 違反必須整篇重寫】以下用語為中國大陸用語，台股分析必須改用台灣用語：
  ✗「同比」「同比增長」「同比增加」 → ✓「年增率」「年增 X%」
  ✗「環比」「環比增長」「環比變動」 → ✓「月增率」「季增率」
  ✗「估值」 → ✓「評價」「本益比評估」
  ✗「賽道」 → ✓「產業」「市場領域」
  ✗「貨幣化」 → ✓「變現」
  ✗「視頻」 → ✓「影片」
  ✗「網絡」 → ✓「網路」
  ✗「數據」 → ✓「資料」

【公司名稱再次確認】本報告分析的公司為 ${companyName}（${analysisTicker}），不是其他任何公司。`;
    try {
      const r = await fetch(`${API_URL}/api/private-ai-query`, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ prompt, pw: PASSWORD })
      });
      const d = await r.json();
      const result = d.result || '';
      setAiInterpret(result);
      try { localStorage.setItem(ck, JSON.stringify({ data: result, ts: Date.now() })); } catch {}
    } catch(e) { setAiInterpret('❌ 失敗'); }
    setAiInterpretLoading(false);
  };

  const runRevAnalysis = async () => {
    setRevLoading(true); setRevAnalysis('');

    // 24小時快取
    const d = new Date();
    const cacheKey = `wintime_rev_${analysisTicker}_${d.getFullYear()}${d.getMonth()}${d.getDate()}`;
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        const { data: cv, ts } = JSON.parse(cached);
        if (Date.now() - ts < 86400000) {
          setRevAnalysis(cv); setRevLoading(false); return;
        }
      }
    } catch {}

    // 按下按鈕時即時抓資料，避免預載競爭問題
    let qData = [], mData = [], aData = [], name = analysisTicker;
    try {
      const [qRes, mRes, aRes, infoRes] = await Promise.all([
        fetch(`${API_URL}/api/company/${analysisTicker}/quarterly?limit=9999`),
        fetch(`${API_URL}/api/company/${analysisTicker}/monthly?limit=9999`),
        fetch(`${API_URL}/api/company/${analysisTicker}/annual`),
        fetch(`${API_URL}/api/company/${analysisTicker}`),
      ]);
      const qj = await qRes.json();
      const mj = await mRes.json();
      const aj = await aRes.json();
      const ij = await infoRes.json();
      if (Array.isArray(qj)) qData = qj;
      if (Array.isArray(mj)) mData = mj;
      if (Array.isArray(aj)) aData = aj;
      if (ij && ij.name) name = ij.name;
    } catch(e) {}

    if (qData.length === 0 && mData.length === 0) {
      setRevAnalysis('❌ 找不到資料，請確認股票代號是否正確');
      setRevLoading(false); return;
    }

    // 整理季度營收（全部歷史，由舊到新）
    const qRevLines = qData.slice().reverse().map(q => {
      const opi = q['營益率'] !== '' && q['營益率'] != null ? `${q['營益率']}%` : '缺';
      return `${q['期別']}：${q['營業收入_億']}億 毛利率${q['毛利率']}% 營益率${opi} 營收年增率${q['營收年增率']}%`;
    }).join('\n');

    // 整理月營收（全部歷史，由舊到新）
    const mRevLines = mData.slice().reverse().map(m =>
      `${m.period}：${m.revenue ? (m.revenue/100000).toFixed(2) : '-'}億 年增率${m.yoy_pct != null ? Number(m.yoy_pct).toFixed(1) : '-'}% 月增率${m.mom_pct != null ? Number(m.mom_pct).toFixed(1) : '-'}%`
    ).join('\n');

    // 整理年度資本支出（由舊到新）
    const capexLines = aData.slice().reverse().map(a =>
      `${a.year}年：營收${a.revenue != null ? Number(a.revenue).toFixed(1) : '-'}億 購置不動產設備${a.capex != null ? Number(a.capex).toFixed(2) : '-'}億（負值=增加設備）`
    ).join('\n');

    const prompt = `【公司鎖定 - 絕對不可違反】
本次分析的公司為：${name}（股票代號 ${analysisTicker}）
你必須只分析這家公司。報告中所有提及的公司名稱、股票代號都必須使用上述資訊。
禁止在報告中出現任何其他公司名稱（例如鴻海、台積電、聯發科等）或其他股票代號，即使資料看起來與其他公司相似也不行。
報告開頭請寫：「# ${analysisTicker}（${name}）營業收入深度分析」

請對 ${name}（${analysisTicker}）的營業收入進行深度分析。

【季度營收（全部歷史資料，由舊到新）】
${qRevLines}

【月營收（全部歷史資料，由舊到新）】
${mRevLines}

【年度營收與資本支出（由舊到新）】
${capexLines}

資料涵蓋完整歷史（從最早有資料的年月起）。請從以下四個面向分析，每個面向200字，具體引用年份與數字：

一、淡旺季規律
分析每年哪幾個月/哪一季是旺季、哪幾個月/季是淡季，並說明規律是否穩定，有無近年變化。

二、景氣循環（擴張與收縮）
從完整歷史年增率的變化，找出每一輪景氣擴張期（年增率持續正成長）和收縮期（年增率持續負成長或下滑）的起訖時間與持續長度，歸納出這家公司歷次景氣循環的規律，並判斷目前處於哪個階段、已持續多久、距離上一次轉折約多少個月。

三、近期趨勢判斷
綜合近3～6個月的月營收和近2～4季的季營收，判斷目前是加速成長、趨緩、還是轉折向上/向下，給出明確判斷。

四、資本支出同步分析
分析歷年購置不動產及設備（資本支出，負號代表現金流出／增加設備）與營收的同步或領先落後關係：在景氣擴張期，資本支出是否同步放大？在景氣收縮期，是否縮手？找出異常的時期（如景氣好卻不擴張設備，或景氣差卻大舉購置設備），給出對公司策略的判斷，並評估目前的擴張或收縮動向。

【絕對禁止】禁止捏造或推估資料中沒有的數字，資料不足時直接說明。
【語言要求】全文使用繁體中文，採台灣慣用語，所有財務名詞一律用中文，不得出現英文縮寫或英文術語。
【嚴禁中國用語 - 違反必須整篇重寫】以下用語為中國大陸用語，台股分析必須改用台灣用語：
  ✗「同比」「同比增長」「同比增加」 → ✓「年增率」「年增 X%」
  ✗「環比」「環比增長」「環比變動」 → ✓「月增率」「季增率」
  ✗「估值」 → ✓「評價」「本益比評估」
  ✗「賽道」 → ✓「產業」「市場領域」
  ✗「貨幣化」 → ✓「變現」
  ✗「視頻」 → ✓「影片」
  ✗「網絡」 → ✓「網路」
  ✗「數據」 → ✓「資料」

【公司名稱再次確認】本報告分析的公司為 ${name}（${analysisTicker}），不是其他任何公司。`;

    try {
      const r = await fetch(`${API_URL}/api/private-ai-query`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt, pw: PASSWORD })
      });
      const d2 = await r.json();
      const result = d2.result || d2.error || '無回應';
      setRevAnalysis(result);
      try { localStorage.setItem(cacheKey, JSON.stringify({ data: result, ts: Date.now() })); } catch {}
    } catch(e) { setRevAnalysis('❌ 失敗'); }
    setRevLoading(false);
  };

  // 一鍵全分析：三個區塊平行跑，財務指標算完後自動接AI解讀
  const runAll = () => {
    runRevAnalysis();
    // 財務指標：先算完再接AI解讀
    (async () => {
      setStatsLoading(true); setStats(null); setAiInterpret('');
      let d;
      try {
        const r = await fetch(`${API_URL}/api/company/${analysisTicker}/radar-stats`);
        d = await r.json();
        setStats(d);
      } catch(e) { setStats({ error: '載入失敗' }); setStatsLoading(false); return; }
      setStatsLoading(false);
      await interpretStats(d); // 直接傳資料，不等React state更新
    })();
  };


  // ════════════════════ 視覺設定（只影響畫面，不動任何邏輯） ════════════════════
  const RADAR_CSS = `
    @keyframes radarPing { 0% { transform: scale(0.6); opacity: 0.9; } 100% { transform: scale(2.6); opacity: 0; } }
    @keyframes radarRise { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
    .radar-mod { animation: radarRise 0.5s cubic-bezier(0.22,1,0.36,1) both; transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s; }
    .radar-mod:hover { border-color: var(--accent); box-shadow: 0 10px 32px rgba(0,0,0,0.5); transform: translateY(-2px); }
    .radar-btn { transition: filter 0.15s, transform 0.08s; }
    .radar-btn:hover:not(:disabled) { filter: brightness(1.18); }
    .radar-btn:active:not(:disabled) { transform: translateY(1px); }
  `;

  const isAllRunning = revLoading || statsLoading || aiInterpretLoading;

  // 模組外殼
  const modCard = (accent) => ({
    background: 'linear-gradient(180deg, #0b121a 0%, #080b10 100%)',
    border: '1px solid #18293a', borderRadius: 6,
    padding: '20px 22px', marginBottom: 14, position: 'relative', overflow: 'hidden',
    ['--accent']: accent,
  });
  const modBar = (accent) => ({
    position: 'absolute', left: 0, top: 0, bottom: 0, width: 3,
    background: `linear-gradient(180deg, ${accent}, transparent)`,
  });
  const modNum = (accent) => ({
    fontFamily: "'Rajdhani',sans-serif", fontSize: 40, fontWeight: 700,
    lineHeight: 0.9, color: accent, opacity: 0.22, minWidth: 56,
  });
  const modTitle = { fontFamily: "'Rajdhani',sans-serif", fontSize: 16, fontWeight: 700, letterSpacing: 2, color: '#cfe6f5' };
  const modDesc = { color: '#5a7890', fontSize: 12, lineHeight: 1.65, marginTop: 3 };
  const actBtn = (accent, solid = true) => ({
    padding: '8px 18px', borderRadius: 4, cursor: 'pointer',
    fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, fontSize: 12, letterSpacing: 1.5, whiteSpace: 'nowrap',
    border: solid ? 'none' : `1px solid ${accent}66`,
    background: solid ? `linear-gradient(135deg, ${accent}, ${accent}bb)` : 'transparent',
    color: solid ? '#06121a' : accent,
  });
  const emptyHint = (icon, text) => (
    <div style={{ border: '1px dashed #1c2c3c', borderRadius: 5, padding: '22px 16px',
      textAlign: 'center', color: '#3a5468', fontSize: 12, lineHeight: 1.7 }}>
      <div style={{ fontSize: 20, marginBottom: 6, opacity: 0.55 }}>{icon}</div>
      {text}
    </div>
  );
  const aiDisclaimer = (
    <div style={{ marginTop: 12, padding: '8px 12px', background: '#1a1a0a',
      border: '1px solid #4a4a20', borderRadius: 4, color: '#a0a060', fontSize: 12 }}>
      ⚠️ AI 報告可能會有錯誤，請務必自行核實數字後再做判斷。
    </div>
  );
  const aiText = { color: '#a8c8e0', fontSize: 14, lineHeight: 2.0, whiteSpace: 'pre-wrap' };

  return (
    <div style={{ padding: '18px 16px 60px', maxWidth: 1100 }}>
      <style>{RADAR_CSS}</style>

      {/* ══════════ Header ══════════ */}
      <div style={{ marginBottom: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 13 }}>
          <div style={{ position: 'relative', width: 13, height: 13, flexShrink: 0 }}>
            <div style={{ position: 'absolute', inset: 3, borderRadius: '50%', background: '#4C9BB8' }} />
            <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '1.5px solid #4C9BB8', animation: 'radarPing 2.4s ease-out infinite' }} />
          </div>
          <div style={{ fontFamily: "'Rajdhani',sans-serif", fontSize: 23, fontWeight: 700, letterSpacing: 3, color: '#cfe6f5' }}>
            財報雷達站
          </div>
        </div>
        <div style={{ color: '#456578', fontSize: 11.5, letterSpacing: 1.5, marginTop: 7, paddingBottom: 14,
          background: 'linear-gradient(90deg, #1e3a52, transparent) left bottom / 100% 1px no-repeat' }}>
          兩組偵測模組 · 掃描個股的營收訊號與財務相關性
        </div>
      </div>

      {/* ══════════ 控制台：選股 + 一鍵全分析 ══════════ */}
      <div style={{ marginBottom: 22, background: 'linear-gradient(135deg, #0c1826, #0a1119)',
        border: '1px solid #1e3a52', borderRadius: 8, padding: '16px 20px',
        display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative' }}>
          <div style={{ fontFamily: "'Rajdhani',sans-serif", fontSize: 9, letterSpacing: 2, color: '#4a6878', fontWeight: 700, marginBottom: 4 }}>SELECT TARGET</div>
          <input value={searchQuery} onChange={e => handleSearch(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter' && searchResults.length > 0) {
                e.preventDefault();
                const first = searchResults[0];
                selectStock(first.ticker, first.name);
              }
            }}
            placeholder="輸入代號或名稱（按 Enter 選第一筆）..."
            autoComplete="off"
            style={{ width: 190, background: '#060910', border: '1px solid #2a5070',
              padding: '8px 12px', color: '#c0d8ea', fontSize: 13, outline: 'none',
              fontFamily: "'Barlow',sans-serif", borderRadius: 4 }} />
          {searchResults.length > 0 && (
            <div style={{ position: 'absolute', top: 58, left: 0, width: 250,
              background: '#0d1820', border: '1px solid #2a4060', borderRadius: 8, zIndex: 100,
              boxShadow: '0 8px 28px rgba(0,0,0,0.6)', overflow: 'hidden' }}>
              {searchResults.map(c => (
                <div key={c.ticker} onClick={() => selectStock(c.ticker, c.name)}
                  style={{ padding: '8px 13px', cursor: 'pointer', display: 'flex', gap: 10, borderBottom: '1px solid #1a2a3c' }}>
                  <span style={{ color: '#4C9BB8', fontWeight: 700, minWidth: 46, fontFamily: "'Rajdhani', sans-serif" }}>{c.ticker}</span>
                  <span style={{ color: '#ccc', fontSize: 12 }}>{c.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        {analysisTicker && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div style={{ fontFamily: "'Rajdhani',sans-serif", fontSize: 9, letterSpacing: 2, color: '#4a6878', fontWeight: 700 }}>LOCKED</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#0d1820',
              border: '1px solid #1e3a5a', borderRadius: 5, padding: '6px 13px' }}>
              <span style={{ color: '#4C9BB8', fontWeight: 700, fontSize: 16, fontFamily: "'Rajdhani', sans-serif" }}>{analysisTicker}</span>
              {companyName && <span style={{ color: '#7ab0cc', fontSize: 13 }}>{companyName}</span>}
            </div>
          </div>
        )}
        <div style={{ flex: 1, minWidth: 10 }} />
        <div style={{ textAlign: 'right' }}>
          <div style={{ color: '#90c0dc', fontWeight: 700, fontSize: 14, marginBottom: 2 }}>🚀 一鍵全分析</div>
          <div style={{ color: '#4a6878', fontSize: 11 }}>同時執行營收分析與財務指標統計分析</div>
        </div>
        <button className="radar-btn" onClick={runAll} disabled={isAllRunning}
          style={{ padding: '11px 30px', borderRadius: 6, border: 'none',
            background: isAllRunning ? '#2a3a48' : 'linear-gradient(135deg, #1a6a96, #4C9BB8)',
            color: '#eef8ff', cursor: isAllRunning ? 'default' : 'pointer',
            fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, fontSize: 15, letterSpacing: 1, whiteSpace: 'nowrap' }}>
          {isAllRunning ? <InlineTimer prefix="⏳ 分析中 " /> : '🚀 一鍵全分析'}
        </button>
      </div>

      {/* ══════════ 模組 01：營收分析 ══════════ */}
      <div className="radar-mod" style={{ ...modCard('#4C9BB8'), animationDelay: '0.05s' }}>
        <div style={modBar('#4C9BB8')} />
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 12 }}>
          <div style={modNum('#4C9BB8')}>01</div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
              <span style={{ fontSize: 16 }}>📈</span>
              <span style={modTitle}>營收分析</span>
            </div>
            <div style={modDesc}>解讀淡旺季規律、景氣循環的擴張與收縮、近期趨勢，以及資本支出與營收的同步性</div>
          </div>
          <button className="radar-btn" style={actBtn('#4C9BB8')} onClick={runRevAnalysis} disabled={revLoading}>
            {revLoading ? '分析中...' : '開始分析'}
          </button>
        </div>
        {revLoading && (
          <div style={{ color: '#7ab0cc', fontSize: 12, padding: '14px 0', letterSpacing: 2 }}>
            ⏳ 正在掃描淡旺季與景氣循環...
          </div>
        )}
        {!revLoading && !revAnalysis && emptyHint('📡', '點擊「開始分析」，營收的淡旺季、景氣循環與趨勢解讀會顯示在這裡')}
        {revAnalysis && (
          <div style={{ ...aiText, borderTop: '1px solid #1a2a3c', paddingTop: 14 }}>
            {revAnalysis}
            {aiDisclaimer}
          </div>
        )}
      </div>

      {/* ══════════ 模組 02：財務指標統計分析 ══════════ */}
      <div className="radar-mod" style={{ ...modCard('#d8a840'), animationDelay: '0.12s' }}>
        <div style={modBar('#d8a840')} />
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 12 }}>
          <div style={modNum('#d8a840')}>02</div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
              <span style={{ fontSize: 16 }}>📐</span>
              <span style={modTitle}>財務指標統計分析</span>
            </div>
            <div style={modDesc}>計算營收與毛利率、存貨、資本支出等的相關係數與落後關係，並回測「存貨增 + 存貨週轉天數下降」的訊號命中率</div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="radar-btn" style={actBtn('#d8a840')} onClick={() => fetchStats(analysisTicker)} disabled={statsLoading}>
              {statsLoading ? '計算中...' : '開始計算'}
            </button>
            {stats && !stats.error && (
              <button className="radar-btn" style={actBtn('#1e8a6a')} onClick={interpretStats} disabled={aiInterpretLoading}>
                {aiInterpretLoading ? 'AI解讀中...' : '🤖 AI解讀'}
              </button>
            )}
          </div>
        </div>

        {statsLoading && (
          <div style={{ color: '#d8a840', fontSize: 12, padding: '14px 0', letterSpacing: 2 }}>⏳ 正在計算相關係數與落後關係...</div>
        )}
        {!statsLoading && !stats && emptyHint('📐', '點擊「開始計算」，營收與各項財務指標的相關性、落後期數與訊號命中率會顯示在這裡')}

        {stats && !stats.error && (
          <div>
            <div style={{ color: '#7ab0cc', fontSize: 10, marginBottom: 12 }}>
              資料期間：{stats.start} ～ {stats.end}（共 {stats.periods} 季）
            </div>

            {/* 相關係數表 */}
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 12, fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#070a0f' }}>
                  {['分析項目','相關係數 r','顯著性 p','解讀'].map(h =>
                    <th key={h} style={{ padding: '5px 10px', textAlign: 'left', color: '#7ab0cc', fontFamily: "'Rajdhani',sans-serif", letterSpacing: 1, borderBottom: '1px solid #1a2a3c', fontWeight: 600 }}>{h}</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {[
                  stats.rev_gp_corr,
                ].filter(Boolean).map((item, i) => {
                  const r = item.r;
                  const level = Math.abs(r) > 0.7 ? {label:'高度相關',color:'#d62828'} : Math.abs(r) > 0.4 ? {label:'中度相關',color:'#d8a840'} : {label:'低度相關',color:'#6a8090'};
                  return (
                    <tr key={i} style={{ background: i%2===0?'#080b10':'#070a0e', borderBottom: '1px solid #0d1820' }}>
                      <td style={{ padding: '5px 10px', color: '#8ab0cc' }}>{item.label}</td>
                      <td style={{ padding: '5px 10px', color: r > 0 ? '#d62828' : '#00a14b', fontFamily: "'JetBrains Mono',monospace", fontWeight: 600 }}>{r}</td>
                      <td style={{ padding: '5px 10px', color: item.p < 0.05 ? '#d62828' : '#6a8090', fontFamily: "'JetBrains Mono',monospace" }}>{item.p < 0.05 ? '★顯著' : item.p}</td>
                      <td style={{ padding: '5px 10px', color: level.color }}>{level.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {/* 落後關係 */}
            <div style={{ color: '#90c0dc', fontSize: 10, letterSpacing: 2, fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, marginBottom: 6 }}>領先指標：科目變動後第 N 季營收跟著反映（可用來預估未來營收）</div>
            {[stats.rev_raw_lag, stats.rev_wip_lag, stats.rev_fg_lag, stats.rev_inv_lag, stats.rev_capex_lag, stats.rev_intg_lag, stats.rev_cl_lag].filter(Boolean).map((item, i) => {
              const best = item.lags[item.best_lag];
              return (
                <div key={i} style={{ marginBottom: 8, padding: '8px 12px', background: '#070a0f', border: '1px solid #0d1820' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: '#8ab0cc', fontSize: 12 }}>{item.label}</span>
                    <span style={{ color: '#d8a840', fontSize: 11, fontFamily: "'JetBrains Mono',monospace" }}>
                      領先 {item.best_lag} 季預告營收 (r={best?.r})
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
                    {Object.entries(item.lags).map(([lag, v]) => (
                      <span key={lag} style={{ fontSize: 11, color: lag==item.best_lag?'#f0c040':'#7ab0cc',
                        background: lag==item.best_lag?'#2a2800':'#0d1620', padding: '3px 10px', borderRadius: 2 }}>
                        領先{lag}季: r={v.r}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}

            {/* 信號分析 */}
            {stats.inv_ar_signal && (
              <div style={{ padding: '10px 14px', background: '#070a0f', border: '1px solid #0d1820', marginTop: 8 }}>
                <div style={{ color: '#90c0dc', fontSize: 10, letterSpacing: 2, fontFamily: "'Rajdhani',sans-serif", fontWeight: 700, marginBottom: 6 }}>信號分析：{stats.inv_ar_signal.label}</div>
                <div style={{ display: 'flex', gap: 20 }}>
                  <span style={{ color: '#8ab0cc', fontSize: 12 }}>歷史信號次數：<b style={{ color: '#c0d8ea' }}>{stats.inv_ar_signal.signals}次</b></span>
                  <span style={{ color: '#8ab0cc', fontSize: 12 }}>命中次數：<b style={{ color: '#d62828' }}>{stats.inv_ar_signal.correct}次</b></span>
                  <span style={{ color: '#8ab0cc', fontSize: 12 }}>命中率：<b style={{ color: stats.inv_ar_signal.hit_rate >= 60 ? '#d62828' : '#d8a840', fontSize: 16 }}>{stats.inv_ar_signal.hit_rate}%</b></span>
                </div>
              </div>
            )}
          </div>
        )}
        {stats?.error && <div style={{ color: '#e0604a', fontSize: 12, padding: '8px 0' }}>❌ {stats.error}</div>}

        {aiInterpret && (
          <div style={{ ...aiText, marginTop: 14, borderTop: '1px solid #1a2a3c', paddingTop: 14 }}>
            {aiInterpret}
            {aiDisclaimer}
          </div>
        )}
      </div>

      {/* ── 易經人生 ── */}
      <div style={{ marginTop: 32, background: '#07090f', border: '1px solid #1a2a3c', borderRadius: 8, padding: '24px 20px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10, marginBottom:12 }}>
          <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:16, fontWeight:700, letterSpacing:3, color:'#D4A017' }}>☯ 易 經 人 生</div>
          <div style={{ fontSize:11, color:'#4a6878', background:'rgba(74,104,120,0.12)', border:'1px solid #2a3a4a', borderRadius:4, padding:'4px 12px' }}>
            科學的盡頭是玄學，純屬娛樂，不可盡信
          </div>
        </div>
        <div style={{ display:'flex', gap:8, marginBottom:12 }}>
          <button onClick={()=>setICategory('invest')} style={{ flex:1, padding:'8px 0', borderRadius:6, border:'none', cursor:'pointer', fontSize:13, fontWeight:700, background: iCategory==='invest' ? 'linear-gradient(135deg,#1a4a2a,#2a7040)' : '#0d1520', color: iCategory==='invest' ? '#4ade80' : '#4a6878', outline: iCategory==='invest' ? '1px solid #2a7040' : '1px solid #1e2a3a' }}>📈 投資理財問題</button>
          <button onClick={()=>setICategory('life')} style={{ flex:1, padding:'8px 0', borderRadius:6, border:'none', cursor:'pointer', fontSize:13, fontWeight:700, background: iCategory==='life' ? 'linear-gradient(135deg,#2a1a3a,#5a3070)' : '#0d1520', color: iCategory==='life' ? '#c084fc' : '#4a6878', outline: iCategory==='life' ? '1px solid #5a3070' : '1px solid #1e2a3a' }}>🌙 人生事項詢問</button>
        </div>
        <input value={iQuestion} onChange={e=>setIQuestion(e.target.value)}
          placeholder={iCategory==='invest' ? '輸入你想問的投資問題，例如：現在適合買進台積電嗎？' : '輸入你想問的人生事項，例如：這段感情值得繼續嗎？'}
          style={{ width:'100%', boxSizing:'border-box', background:'#060910', border:'1px solid #2a5070', borderRadius:4, color:'#c0d8ea', padding:'9px 12px', fontSize:13, outline:'none', marginBottom:12 }} />
        <div style={{ textAlign:'center', marginBottom:20 }}>
          <button onClick={iCast} disabled={iCasting||iLoading} style={{ padding:'10px 36px', borderRadius:6, border:'none', cursor:(iCasting||iLoading)?'not-allowed':'pointer', background:(iCasting||iLoading)?'#2a3a4a':'linear-gradient(135deg,#7a3810,#c8940f)', color:'#fff', fontSize:16, fontWeight:700, letterSpacing:4 }}>
            {iCasting ? '🌀 起卦中...' : iLoading ? '🔮 解卦中...' : '✦ 起　卦 ✦'}
          </button>
        </div>
        {iHexNum && iLines && (() => {
          const hex = I_HEXAGRAMS[iHexNum];
          const lower = I_TRIGRAMS[iLinesToTrigram(iLines.slice(0,3))];
          const upper = I_TRIGRAMS[iLinesToTrigram(iLines.slice(3,6))];
          return (
            <div style={{ background:'#0a0d16', border:'1px solid #2a3a4a', borderRadius:8, padding:20 }}>
              <div style={{ textAlign:'center', marginBottom:16 }}>
                <div style={{ fontSize:11, color:'#4a6878', marginBottom:3 }}>第 {iHexNum} 卦</div>
                <div style={{ fontSize:22, fontWeight:700, color:'#f5c518', marginBottom:4 }}>{hex.full}</div>
                <div style={{ fontSize:12, color:'#7ab0cc' }}>{upper.symbol} {upper.name}（{upper.element}）上　{lower.symbol} {lower.name}（{lower.element}）下</div>
                <div style={{ marginTop:6, fontSize:12, color:'#D4A017', background:'rgba(212,160,23,0.1)', borderRadius:3, padding:'2px 10px', display:'inline-block' }}>{hex.theme}</div>
              </div>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:7, marginBottom:16 }}>
                {[5,4,3,2,1,0].map(i=>(
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ fontSize:10, color:'#4a6878', width:24, textAlign:'right' }}>{['初','二','三','四','五','上'][i]}爻</div>
                    <ILine isYang={iLines[i]===1} visible={iVisible>i} />
                  </div>
                ))}
              </div>
              {(iLoading||iInterp) && (
                <div style={{ borderTop:'1px solid #1e2a3a', paddingTop:14 }}>
                  <div style={{ fontSize:12, color:'#f5c518', marginBottom:8, fontWeight:600 }}>🔮 卦象解析</div>
                  {iLoading && !iInterp
                    ? <div style={{ color:'#4a6878', fontSize:13 }}>⏳ 正在為你解卦...</div>
                    : <div style={{ fontSize:13, lineHeight:1.9, color:'#c0d8ea', whiteSpace:'pre-wrap' }}>{iInterp}</div>
                  }
                </div>
              )}
            </div>
          );
        })()}
        {!iHexNum && (
          <div style={{ textAlign:'center', color:'#4a6878', fontSize:13, padding:'20px 0' }}>心誠則靈，點擊「起卦」開始占卜</div>
        )}
      </div>

      {/* ── 杯柄形態選股 ── */}
      <div style={{
        marginTop: 24, marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a',
        borderRadius: 10, padding: 16,
      }}>
        <div onClick={() => setOpenSec(s => ({ ...s, cup: !s.cup }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#f5c518' }}>
            {openSec.cup ? '▼' : '▶'} 🏆 杯柄形態選股
          </div>
          {cupHandle?.signal_date && (
            <div style={{ fontSize: 11, color: '#4a6878' }}>掃描日期：{cupHandle.signal_date}　共 {cupHandle.count} 檔</div>
          )}
        </div>
        {openSec.cup && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          依威廉歐尼爾杯柄選股法偵測：先漲→回檔形成杯型→縮量整理形成柄→放量突破。
        </div>

        {cupLoading && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>
        )}

        {!cupLoading && (!cupHandle || cupHandle.count === 0) && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>
            目前無符合杯柄形態的股票，或尚未執行掃描。
          </div>
        )}

        {!cupLoading && cupHandle && cupHandle.signals && cupHandle.signals.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 700 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                  <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left',  color: '#7ab0cc' }}>股票</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>收盤價</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700 }}>突破點</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>距突破點</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>杯深</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>杯週數</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left',  color: '#7ab0cc' }}>狀態</th>
                </tr>
              </thead>
              <tbody>
                {cupHandle.signals.map(s => {
                  const pct = s.pct_from_breakout;
                  const pctColor = pct > 1 ? '#d62828' : pct > -3 ? '#f5c518' : '#7ab0cc';
                  const inWatch = watchlistSet.has(s.ticker);
                  return (
                    <tr key={s.ticker}
                      style={{ borderBottom: '1px solid #131c26' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }}
                        onClick={() => toggleWatchlist(s.ticker, s.name)}>
                        <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                        <span style={{ color: '#ccc' }}>{s.name}</span>
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#ddd', fontSize: 14 }}>
                        {s.current_price?.toLocaleString() ?? '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700, fontSize: 14 }}>
                        {s.breakout_price?.toLocaleString() ?? '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: 700, fontSize: 14, color: pctColor }}>
                        {pct != null ? (pct > 0 ? '+' : '') + pct.toFixed(1) + '%' : '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>
                        {s.cup_depth_pct != null ? s.cup_depth_pct.toFixed(1) + '%' : '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>
                        {s.cup_weeks != null ? s.cup_weeks + 'W' : '-'}
                      </td>
                      <td style={{ padding: '8px 10px', fontSize: 12 }}>{s.status ?? '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        </>)}
      </div>

      {/* ── 旱地拔蔥形態選股 ── */}
      <div style={{
        marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a',
        borderRadius: 10, padding: 16,
      }}>
        <div onClick={() => setOpenSec(s => ({ ...s, drought: !s.drought }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#22c55e' }}>
            {openSec.drought ? '▼' : '▶'} 🌱 旱地拔蔥形態選股
          </div>
          {drought?.signal_date && (
            <div style={{ fontSize: 11, color: '#4a6878' }}>掃描日期：{drought.signal_date}　共 {drought.count} 檔</div>
          )}
        </div>
        {openSec.drought && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          近期成交量加溫（近20日均量 &gt; 年均量 1.3 倍）→ 收盤突破一年新高，放量突破是主力進場訊號。
        </div>

        {droughtLoading && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>
        )}

        {!droughtLoading && (!drought || drought.count === 0) && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>
            目前無符合旱地拔蔥形態的股票，或尚未執行掃描。
          </div>
        )}

        {!droughtLoading && drought && drought.signals && drought.signals.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 680 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                  <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left',  color: '#7ab0cc' }}>股票</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>收盤價</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#22c55e', fontWeight: 700 }}>年高點</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>突破幅度</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>量比</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left',  color: '#7ab0cc' }}>狀態</th>
                </tr>
              </thead>
              <tbody>
                {drought.signals.map(s => {
                  const inWatch = watchlistSet.has(s.ticker);
                  return (
                    <tr key={s.ticker}
                      style={{ borderBottom: '1px solid #131c26' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }}
                        onClick={() => toggleWatchlist(s.ticker, s.name)}>
                        <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                        <span style={{ color: '#ccc' }}>{s.name}</span>
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#ddd', fontSize: 14 }}>
                        {s.current_price?.toLocaleString() ?? '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#22c55e', fontWeight: 700, fontSize: 14 }}>
                        {s.year_high?.toLocaleString() ?? '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>
                        {s.breakout_pct != null ? '+' + s.breakout_pct.toFixed(2) + '%' : '-'}
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>
                        {s.volume_ratio != null ? s.volume_ratio.toFixed(2) + 'x' : '-'}
                      </td>
                      <td style={{ padding: '8px 10px', fontSize: 12 }}>{s.status ?? '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        </>)}
      </div>

      {/* ── 大戶籌碼週增減排行 ── */}
      <div style={{
        marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a',
        borderRadius: 10, padding: 16,
      }}>
        <div onClick={() => setOpenSec(s => ({ ...s, big: !s.big }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#FFD700' }}>
            {openSec.big ? '▼' : '▶'} 🐋 大戶籌碼週增減前50名
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {bigHolders?.date_new && (
              <div style={{ fontSize: 11, color: '#4a6878' }}>
                本週：{bigHolders.date_new}　上週：{bigHolders.date_old}
              </div>
            )}
            <button onClick={(e) => { e.stopPropagation(); setBigHoldersTab('increase'); }} style={{
              padding: '4px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600,
              border: bigHoldersTab === 'increase' ? '1px solid #FFD70060' : '1px solid #1e2a3a',
              background: bigHoldersTab === 'increase' ? 'rgba(255,215,0,0.12)' : 'transparent',
              color: bigHoldersTab === 'increase' ? '#FFD700' : '#5a7888',
            }}>▲ 週增</button>
            <button onClick={(e) => { e.stopPropagation(); setBigHoldersTab('decrease'); }} style={{
              padding: '4px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600,
              border: bigHoldersTab === 'decrease' ? '1px solid #e5484860' : '1px solid #1e2a3a',
              background: bigHoldersTab === 'decrease' ? 'rgba(229,72,72,0.12)' : 'transparent',
              color: bigHoldersTab === 'decrease' ? '#e54848' : '#5a7888',
            }}>▼ 週減</button>
          </div>
        </div>
        {openSec.big && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          集保持股分級 9-15 級（單一帳戶持股 50,000 股以上）合計張數，本週 vs 上週{bigHoldersTab === 'increase' ? '增加' : '減少'}最多的前 50 檔。
        </div>

        {bigHoldersLoading && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>
        )}

        {!bigHoldersLoading && (() => {
          const data = bigHoldersTab === 'increase' ? bigHolders : bigHoldersDecr;
          if (!data || data.count === 0) return (
            <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>
              尚無集保籌碼資料，請先執行集保更新。
            </div>
          );
          const isDecr = bigHoldersTab === 'decrease';
          return (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 680 }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                    <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                    <th style={{ padding: '8px 6px', textAlign: 'right', color: '#4a6878', width: 36 }}>#</th>
                    <th style={{ padding: '8px 10px', textAlign: 'left',  color: '#7ab0cc' }}>股票</th>
                    <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>收盤價</th>
                    <th style={{ padding: '8px 10px', textAlign: 'right', color: isDecr ? '#e54848' : '#FFD700', fontWeight: 700 }}>
                      {isDecr ? '持股比減少(pp)' : '持股比增加(pp)'}
                    </th>
                    <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>本週持股比</th>
                    <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>上週持股比</th>
                    <th style={{ padding: '8px 10px', textAlign: 'right', color: '#22c55e' }}>大戶佔比%</th>
                  </tr>
                </thead>
                <tbody>
                  {data.signals.map((s, i) => {
                    const inWatch = watchlistSet.has(s.ticker);
                    const diffColor = isDecr
                      ? (i < 3 ? '#e54848' : '#f08080')
                      : (i < 3 ? '#FFD700' : '#f5c518');
                    return (
                      <tr key={s.ticker}
                        style={{ borderBottom: '1px solid #131c26' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }}
                          onClick={() => toggleWatchlist(s.ticker, s.name)}>
                          <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                        </td>
                        <td style={{ padding: '8px 6px', textAlign: 'right', color: i < 3 ? diffColor : '#4a6878', fontWeight: i < 3 ? 800 : 400 }}>
                          {i + 1}
                        </td>
                        <td style={{ padding: '8px 10px' }}>
                          <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                          <span style={{ color: '#ccc' }}>{s.name}</span>
                        </td>
                        <td style={{ padding: '8px 10px', textAlign: 'right', color: '#ddd', fontFamily: 'monospace' }}>
                          {s.current_price?.toLocaleString() ?? '-'}
                        </td>
                        <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: 800, fontSize: 15, color: diffColor }}>
                          {s.pct_diff_pp != null ? (isDecr ? '' : '+') + s.pct_diff_pp.toFixed(2) + 'pp' : '-'}
                        </td>
                        <td style={{ padding: '8px 10px', textAlign: 'right', color: '#ddd' }}>
                          {s.big_pct != null ? s.big_pct.toFixed(2) + '%' : '-'}
                        </td>
                        <td style={{ padding: '8px 10px', textAlign: 'right', color: '#888' }}>
                          {s.big_pct_old != null ? s.big_pct_old.toFixed(2) + '%' : '-'}
                        </td>
                        <td style={{ padding: '8px 10px', textAlign: 'right', color: s.big_pct >= 60 ? '#FFD700' : s.big_pct >= 40 ? '#22c55e' : '#7ab0cc', fontWeight: 600 }}>
                          {s.big_pct != null ? s.big_pct.toFixed(1) + '%' : '-'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })()}
        </>)}
      </div>

      {/* ── EPS 加速選股 ── */}
      <div style={{ marginTop: 24, marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a', borderRadius: 10, padding: 16 }}>
        <div onClick={() => setOpenSec(s => ({ ...s, eps: !s.eps }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#90d8b0' }}>{openSec.eps ? '▼' : '▶'} 📈 EPS 加速選股</div>
          {epsAccel?.updated_at && (<div style={{ fontSize: 11, color: '#4a6878' }}>更新：{epsAccel.updated_at}　共 {epsAccel.count} 檔</div>)}
        </div>
        {openSec.eps && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          最近1季EPS &gt; 前2季EPS加總，且這3季EPS皆未虧損。依超出幅度排序，獲利加速最強者在前。
        </div>
        {epsAccelLoading && (<div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>)}
        {!epsAccelLoading && (!epsAccel || epsAccel.count === 0) && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>目前無符合條件的股票，或尚未執行掃描。</div>
        )}
        {!epsAccelLoading && epsAccel && epsAccel.signals && epsAccel.signals.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 640 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                  <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#7ab0cc' }}>股票</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0' }}>分類</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>股價</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>季別</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#90d8b0', fontWeight: 700 }}>最近季EPS</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>前2季加總</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700 }}>超出</th>
                </tr>
              </thead>
              <tbody>
                {epsAccel.signals.map(s => {
                  const inWatch = watchlistSet.has(s.ticker);
                  return (
                    <tr key={s.ticker} style={{ borderBottom: '1px solid #131c26' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }} onClick={() => toggleWatchlist(s.ticker, s.name)}>
                        <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                        <span style={{ color: '#ccc' }}>{s.name}</span>
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0', fontSize: 12 }}>{s.category || '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>{s.price != null ? s.price : '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa', fontSize: 12 }}>{s.period}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#90d8b0', fontWeight: 700, fontSize: 14 }}>{s.eps_latest}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>{s.eps_prev2_sum}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700, fontSize: 14 }}>+{s.excess}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        </>)}
      </div>

      {/* ── 毛利營益率連升選股 ── */}
      <div style={{ marginTop: 24, marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a', borderRadius: 10, padding: 16 }}>
        <div onClick={() => setOpenSec(s => ({ ...s, mr: !s.mr }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#7fc8e8' }}>{openSec.mr ? '▼' : '▶'} 📊 毛利營益率連升選股</div>
          {marginRising?.updated_at && (<div style={{ fontSize: 11, color: '#4a6878' }}>更新：{marginRising.updated_at}　共 {marginRising.count} 檔</div>)}
        </div>
        {openSec.mr && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          毛利率「且」營益率都連續上升至少 2 季。依毛利率連升季數排序，連升越多季者在前。
        </div>
        {marginRisingLoading && (<div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>)}
        {!marginRisingLoading && (!marginRising || marginRising.count === 0) && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>目前無符合條件的股票，或尚未執行掃描。</div>
        )}
        {!marginRisingLoading && marginRising && marginRising.signals && marginRising.signals.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 760 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                  <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#7ab0cc' }}>股票</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0' }}>分類</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>股價</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700 }}>毛利率連升</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7fc8e8', fontWeight: 700 }}>最新毛利率</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700 }}>營益率連升</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7fc8e8', fontWeight: 700 }}>最新營益率</th>
                </tr>
              </thead>
              <tbody>
                {marginRising.signals.map(s => {
                  const inWatch = watchlistSet.has(s.ticker);
                  return (
                    <tr key={s.ticker} style={{ borderBottom: '1px solid #131c26' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }} onClick={() => toggleWatchlist(s.ticker, s.name)}>
                        <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                        <span style={{ color: '#ccc' }}>{s.name}</span>
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0', fontSize: 12 }}>{s.category || '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>{s.price != null ? s.price : '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700, fontSize: 14 }}>{s.rising_quarters} 季</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#7fc8e8', fontWeight: 700, fontSize: 14 }}>{s.gm_latest}%</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700, fontSize: 14 }}>{s.om_rising} 季</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#7fc8e8', fontWeight: 700, fontSize: 14 }}>{s.om_latest}%</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        </>)}
      </div>

      {/* ── ROIC動能選股 ── */}
      <div style={{ marginTop: 24, marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a', borderRadius: 10, padding: 16 }}>
        <div onClick={() => setOpenSec(s => ({ ...s, roic: !s.roic }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#3ed888' }}>{openSec.roic ? '▼' : '▶'} 🧭 ROIC動能選股</div>
          {roicMomentum?.updated_at && (<div style={{ fontSize: 11, color: '#4a6878' }}>更新：{roicMomentum.updated_at}　共 {roicMomentum.count} 檔</div>)}
        </div>
        {openSec.roic && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          兩個條件互為獨立(符合任一即入榜，各自標記)：條件A「ROIC連三季上升」；條件B「最近1季ROIC為近20季(現有資料內)最高或次高」。ROIC=單季NOPAT÷投入資本，稅率固定20%。
        </div>
        {roicMomentumLoading && (<div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>)}
        {!roicMomentumLoading && (!roicMomentum || roicMomentum.count === 0) && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>目前無符合條件的股票，或尚未執行掃描。</div>
        )}
        {!roicMomentumLoading && roicMomentum && roicMomentum.signals && roicMomentum.signals.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 760 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                  <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#7ab0cc' }}>股票</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0' }}>分類</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>股價</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#3ed888', fontWeight: 700 }}>最近1季ROIC</th>
                  <th style={{ padding: '8px 10px', textAlign: 'center', color: '#f5c518', fontWeight: 700 }}>條件A 連三季上升</th>
                  <th style={{ padding: '8px 10px', textAlign: 'center', color: '#f5c518', fontWeight: 700 }}>條件B 近20季最高/次高</th>
                </tr>
              </thead>
              <tbody>
                {roicMomentum.signals.map(s => {
                  const inWatch = watchlistSet.has(s.ticker);
                  return (
                    <tr key={s.ticker} style={{ borderBottom: '1px solid #131c26' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }} onClick={() => toggleWatchlist(s.ticker, s.name)}>
                        <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                        <span style={{ color: '#ccc' }}>{s.name}</span>
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0', fontSize: 12 }}>{s.category || '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>{s.price != null ? s.price : '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#3ed888', fontWeight: 700, fontSize: 14 }}>{s.roic_latest}%</td>
                      <td style={{ padding: '8px 10px', textAlign: 'center' }}>{s.roic_up3 ? <span style={{ color: '#ffe100', fontWeight: 900 }}>▲ 是</span> : <span style={{ color: '#4a6878' }}>-</span>}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'center' }}>{s.roic_top2 ? <span style={{ color: '#f04545', fontWeight: 900 }}>第{s.roic_rank}高</span> : <span style={{ color: '#4a6878' }}>-</span>}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        </>)}
      </div>

      {/* ── 總幹事選股 ── */}
      <div style={{ marginTop: 24, marginBottom: 16, background: '#0d1520', border: '1px solid #1e2a3a', borderRadius: 10, padding: 16 }}>
        <div onClick={() => setOpenSec(s => ({ ...s, master: !s.master }))} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, flexWrap: 'wrap', gap: 10, cursor: 'pointer' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#e0a040' }}>{openSec.master ? '▼' : '▶'} 🎯 總幹事選股法</div>
          {masterScreen?.updated_at && (<div style={{ fontSize: 11, color: '#4a6878' }}>更新：{masterScreen.updated_at}　共 {masterScreen.count} 檔</div>)}
        </div>
        {openSec.master && (<>
        <div style={{ fontSize: 11, color: '#4a6878', marginBottom: 12, lineHeight: 1.6 }}>
          六大財務條件全部符合的精選股：6個月營收年增&gt;25%且不墜、營益率穩定、稅後淨利連續成長、近4季EPS累積&gt;5元、存貨週轉天數穩定、修正式自由現金流連6季為正。條件嚴格，選出檔數通常很少。
        </div>
        {masterLoading && (<div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>⏳ 載入中…</div>)}
        {!masterLoading && (!masterScreen || masterScreen.count === 0) && (
          <div style={{ padding: 20, textAlign: 'center', color: '#4a6878', fontSize: 13 }}>目前無符合條件的股票，或尚未執行掃描。</div>
        )}
        {!masterLoading && masterScreen && masterScreen.signals && masterScreen.signals.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'monospace', minWidth: 820 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #2a3a4a', background: '#080d14' }}>
                  <th style={{ padding: '8px 8px', textAlign: 'center', color: '#4a6878', width: 36 }}>私房</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#7ab0cc' }}>股票</th>
                  <th style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0' }}>分類</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>股價</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#90d8b0', fontWeight: 700 }}>近4季EPS</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7fc8e8', fontWeight: 700 }}>平均營益率</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700 }}>淨利年增</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>6月營收年增</th>
                  <th style={{ padding: '8px 10px', textAlign: 'right', color: '#7ab0cc' }}>存貨天數</th>
                </tr>
              </thead>
              <tbody>
                {masterScreen.signals.map(s => {
                  const inWatch = watchlistSet.has(s.ticker);
                  return (
                    <tr key={s.ticker} style={{ borderBottom: '1px solid #131c26' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#121c28'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '8px 8px', textAlign: 'center', cursor: 'pointer' }} onClick={() => toggleWatchlist(s.ticker, s.name)}>
                        <div style={{ width: 22, height: 22, borderRadius: 5, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#22c55e', border: inWatch ? '2px solid #22c55e' : '2px solid #2a3a4a', background: inWatch ? 'rgba(34,197,94,0.15)' : 'transparent' }}>{inWatch ? '✓' : ''}</div>
                      </td>
                      <td style={{ padding: '8px 10px' }}>
                        <span style={{ color: '#4C9BB8', fontWeight: 700, marginRight: 6, fontFamily: "'Rajdhani', sans-serif" }}>{s.ticker}</span>
                        <span style={{ color: '#ccc' }}>{s.name}</span>
                      </td>
                      <td style={{ padding: '8px 10px', textAlign: 'left', color: '#c8a8e0', fontSize: 12 }}>{s.category || '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#e0c878' }}>{s.price != null ? s.price : '-'}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#90d8b0', fontWeight: 700, fontSize: 14 }}>{s.eps_sum4}</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#7fc8e8', fontWeight: 700, fontSize: 14 }}>{s.om_avg}%</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#f5c518', fontWeight: 700, fontSize: 14 }}>{s.ni_yoy}%</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>{s.rev_yoy_min}%</td>
                      <td style={{ padding: '8px 10px', textAlign: 'right', color: '#aaa' }}>{s.inv_days_avg}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        </>)}
      </div>

    </div>
  );
}
